import Select from "react-select";
import { cn } from "@/lib/tailwind";

interface Option {
  label: string;
  value: string;
}

interface MultiSelectProps {
  options: Option[];
  selected: string[];
  onChange: (selectedValues: string[]) => void;
  placeholder?: string;
  className?: string;
}

export function MultiSelect({
  options,
  selected,
  onChange,
  placeholder,
  className,
}: MultiSelectProps) {
  return (
    <Select
      isMulti
      options={options}
      value={options.filter((option) => selected.includes(option.value))}
      onChange={(selectedOptions) =>
        onChange(selectedOptions.map((option) => option.value))
      }
      placeholder={placeholder || "Select..."}
      className={cn("text-black min-w-[8rem]", className)}
      styles={{
        control: (base) => ({
          ...base,
          backgroundColor: "white",
          borderColor: "rgb(228 228 231)",
          borderRadius: "0.5rem",
          minHeight: "36px",
          boxShadow: "none",
          "&:hover": {
            borderColor: "rgb(161 161 170)",
          },
          padding: "0px 4px",
        }),
        menu: (base) => ({
          ...base,
          backgroundColor: "white",
          borderRadius: "0.5rem",
          boxShadow:
            "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
          overflow: "hidden",
          border: "1px solid rgb(228 228 231)",
          width: "auto",
          minWidth: "100%",
        }),
        menuList: (base) => ({
          ...base,
          padding: "4px",
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected
            ? "rgb(244 244 245)"
            : state.isFocused
            ? "rgb(244 244 245)"
            : "transparent",
          color: "rgb(24 24 27)",
          borderRadius: "0.375rem",
          "&:hover": {
            backgroundColor: "rgb(244 244 245)",
          },
          cursor: "pointer",
          padding: "6px 8px",
          fontSize: "0.875rem",
        }),
        multiValue: (base) => ({
          ...base,
          backgroundColor: "rgb(244 244 245)",
          borderRadius: "0.375rem",
          border: "1px solid rgb(228 228 231)",
          padding: "0px",
          margin: "1px 2px",
        }),
        multiValueLabel: (base) => ({
          ...base,
          color: "rgb(24 24 27)",
          padding: "1px 4px",
          fontSize: "0.75rem",
          fontWeight: 500,
        }),
        multiValueRemove: (base) => ({
          ...base,
          color: "rgb(113 113 122)",
          borderRadius: "0 0.375rem 0.375rem 0",
          padding: "0 3px",
          "&:hover": {
            backgroundColor: "rgb(228 228 231)",
            color: "rgb(24 24 27)",
          },
          cursor: "pointer",
        }),
        placeholder: (base) => ({
          ...base,
          color: "rgb(161 161 170)",
          fontSize: "0.875rem",
        }),
        input: (base) => ({
          ...base,
          color: "rgb(24 24 27)",
          margin: "0",
          padding: "0",
          fontSize: "0.875rem",
        }),
        indicatorsContainer: (base) => ({
          ...base,
          "> div": {
            padding: "4px",
          },
        }),
        clearIndicator: (base) => ({
          ...base,
          color: "rgb(161 161 170)",
          padding: "2px",
          "&:hover": {
            color: "rgb(24 24 27)",
          },
          cursor: "pointer",
        }),
        dropdownIndicator: (base) => ({
          ...base,
          color: "rgb(161 161 170)",
          padding: "2px",
          "&:hover": {
            color: "rgb(24 24 27)",
          },
          cursor: "pointer",
        }),
        valueContainer: (base) => ({
          ...base,
          padding: "0px 2px",
        }),
      }}
    />
  );
}
